import {
   CurrentHealthcareProviderP1ConfigurationQuery,
   CurrentHealthcareProviderP1ConfigurationSetCommand,
   HealthcareProviderP1Configuration,
   IdentifierEndsWithZeroFault,
} from '@dreryk/egabinet-p1-frontend-api';

import {
   useCqrsCommand,
   UseCqrsCommandResult,
   useCqrsFind,
   UseCqrsQueryResult,
} from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

export type GetP1IdentifierOnSuccessAction = (
   p1Identifier: HealthcareProviderP1Configuration['externalId'] | null
) => void;
type SetP1IdentifierParameters = string;

export const useGetP1Configuration = (
   onSuccess: GetP1IdentifierOnSuccessAction
): UseCqrsQueryResult<HealthcareProviderP1Configuration | null> => {
   return useCqrsFind<HealthcareProviderP1Configuration | null>(
      () => new CurrentHealthcareProviderP1ConfigurationQuery(),
      {
         onSuccess: (data) => {
            onSuccess(data?.externalId ?? null);
         },
      }
   );
};

export const useSetP1Identifier = (onSuccess: VoidFunction): UseCqrsCommandResult<void, SetP1IdentifierParameters> => {
   return useCqrsCommand<void, SetP1IdentifierParameters, IdentifierEndsWithZeroFault>(
      (identifier) => {
         const command = new CurrentHealthcareProviderP1ConfigurationSetCommand();
         command.externalId = identifier;
         return command;
      },
      {
         onSuccess: () => {
            onSuccess();
            dispatchSnackbarPositiveEvent(
               'healthCareInstitution:communicationWithP1:p1Identifier:saveP1IdentifierSuccess'
            );
         },
         onFault: {
            'egabinet-p1-frontend-api:IdentifierEndsWithZeroFault': () =>
               dispatchSnackbarNegativeEvent(
                  'healthCareInstitution:communicationWithP1:p1CertificatesForm:submissionErrors:identifierEndsWithZero'
               ),
         },
      }
   );
};
